import { atom } from 'jotai';

export interface InspectionSessionState {
  /** The URL token that was exchanged to obtain this session. Used to detect a
   *  token change when navigating between inspection links in the same SPA
   *  session, so that a stale session from link A is never reused for link B. */
  sourceToken: string;
  sessionToken: string;
  tenantName: string;
  label: string;
  capabilities: string[];
  consultedAt: string;
  linkExpiresAt: string;
  tenantCodiceFiscale: string | null;
}

export const inspectionSessionAtom = atom<InspectionSessionState | null>(null);
